import { __assign, __rest } from "tslib";
import * as React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import { createStyles } from '@material-ui/core/styles';
import { default as MuiTab } from '@material-ui/core/Tab';
import clsx from 'clsx';
import { TabVariant } from './Tab.types';
export var styles = function (theme) {
    return createStyles({
        fullWidth: {
            flex: 1,
            minWidth: 0,
        },
        nonFullWidth: {
            // Do not wrap text in a Tab - used when tabs are not full width
            maxWidth: '10000px', // Want the max to be infinite, tried undefined and didn't work
        },
        global: {
            padding: '16px',
            fontSize: theme.typography.fontSizeLarge,
        },
        section: {
            padding: '12px',
            fontSize: theme.typography.fontSizeDefault,
        },
        root: {},
        labelIcon: {},
        textColorInherit: {},
        textColorPrimary: {},
        textColorSecondary: {},
        selected: {},
        disabled: {},
        wrapper: {},
    });
};
export var Tab = React.forwardRef(function (props, ref) {
    var _a;
    var classes = props.classes, fullWidth = props.fullWidth, variant = props.variant, other = __rest(props, ["classes", "fullWidth", "variant"]);
    var rootClasses = clsx((_a = {},
        _a[classes.nonFullWidth] = !fullWidth,
        _a[classes.global] = variant === TabVariant.global,
        _a[classes.section] = variant === TabVariant.section,
        _a), classes.root);
    return (React.createElement(MuiTab, __assign({ classes: {
            root: rootClasses,
            labelIcon: classes.labelIcon,
            textColorInherit: classes.textColorInherit,
            textColorPrimary: classes.textColorPrimary,
            textColorSecondary: classes.textColorSecondary,
            selected: classes.selected,
            disabled: classes.disabled,
            fullWidth: classes.fullWidth,
            wrapper: classes.wrapper,
        }, fullWidth: fullWidth, ref: ref }, other)));
});
export default withStyles(styles)(Tab);
//# sourceMappingURL=Tab.js.map